export default "__VITE_ASSET__BEYnxgKT__"